import { z } from 'zod/v4'

/**
 * How current the data of a screen is. EVERY screen carries it (`defineScreen` refuses a response without this exact
 * schema), so a figure is never shown without saying whether it is fresh, stale, being built or failed.
 */
const freshnessBase = {
  /** The version of the data the screen was built from, e.g. `audit:8841`. */
  version: z.string().min(1),
  generatedAt: z.iso.datetime(),
}

export const freshnessSchema = z.discriminatedUnion('state', [
  /** `progress` (0 to 1) exists only while `state` is `building`. */
  z.strictObject({
    ...freshnessBase,
    state: z.literal('building'),
    progress: z.number().min(0).max(1).optional(),
  }),
  z.strictObject({ ...freshnessBase, state: z.enum(['fresh', 'stale', 'failed']) }),
])
export type Freshness = z.infer<typeof freshnessSchema>
